// Single emotional, high-filter funnel with full contact qualification.
const emotionalShort = {
    id: 'emotional-short',
    family: 'short',
    name: 'Emotional Full',
    intro: 'Wir verhandeln für Sie. Sie erhalten die besten Angebote.',
    contactTitle: 'Ihre Angebote sind bereit',
    contactSubtitle: 'Bestätigen Sie, um Ihre besten Angebote zu erhalten.',
    // Funnel sequence tightened 2026-05-27 per the 14-day drop-off audit:
    //   - Removed 'address' step (61 % drop, optional, recoverable post-submit
    //     via the partial-lead enrich endpoint).
    //   - Removed the standalone 'name' step (36 % drop). Name fields now live
    //     inside the 'phone' step UI so visitors give name + phone in one go
    //     instead of two screens.
    //   - 'email' step retained (still optional, low drop) so the lead has a
    //     non-phone fallback channel.
    // Net: 7 steps -> 5 steps, two highest-friction screens collapsed.
    steps: [
        { key: 'property_filter', label: 'Objekt' },
        { key: 'service_selection', label: 'Leistung' },
        { key: 'location', label: 'PLZ' },
        { key: 'email', label: 'E-Mail', optional: true },
        { key: 'phone', label: 'Kontakt' },
    ],
};

const funnelVariants = [emotionalShort];

export const getAllFunnelVariants = () => funnelVariants;

// Branch by id (previously ignored the arg and always returned emotionalShort).
// Falls back to emotionalShort for unknown ids, so existing callers that pass
// 'guided-standard' keep today's behaviour while future per-product (PV/WP)
// variants resolve correctly once added to funnelVariants.
//
// NOTE: service_selection is intentionally KEPT in the base steps. The
// activeFunnel prepend branch in LeadFunnel.vue is dead (resolvedService
// defaults to 'wp', so it is never falsy), which means the base array is the
// only source of that step - removing it would drop the "Leistung" tap from
// every domain. The easy first taps are the foot-in-the-door that drive the
// step-advance rate, so they stay.
export const getFunnelVariant = (variantId = 'emotional-short') =>
    funnelVariants.find((v) => v.id === variantId) || emotionalShort;
